module.exports = __webpack_public_path__ + "static/media/cd.ee26ac27.svg";